<script setup lang="ts">
import { useRouter } from 'vue-router';
import { Finanzmanager } from "@/application/router/types/types";
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';
import { throwableCall } from '@/api/lib/integration.ts';
import { deleteBanksApiUser } from '@/api/banking/banksApi.ts';
import { useBankingStore } from '@/banking/store/bankingStore.ts';
import { captureException } from '@sentry/vue';
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { TrackEventCategory } from '@/application/utils/tracking/events';

const router = useRouter();
const bankingStore = useBankingStore();

async function onOpenRegprotect(e: CustomEvent) {
  const { sessionLink } = e.detail;
  await router.push({ path: '/banking/regprotect', query: { sessionLink } });
}

async function onOpenBankingView() {
  await router.push('/banking?refresh=true');
}

async function onDeleteUser() {
  try {
    await throwableCall(deleteBanksApiUser())
    useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'deleteUser' });
  } catch (err) {
    captureException(err);
  } finally {
    bankingStore.$reset();
    await router.push({ name: Finanzmanager.VERTRAEGE });
  }
}
</script>

<template>
  <BankingWrapper v-slot="{ token }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <!-- eslint-disable vue/attribute-hyphenation -->
    <ba-bam-dashboard
      ref="bam-dashboard"
      :token="token"
      tenantId="21487bb8-d5b4-4a33-9b7a-c02637e6574d"
      enableUserDeletion
      @openRegprotect="onOpenRegprotect"
      @openBankingView="onOpenBankingView"
      @deleteUser="onDeleteUser"
    />
  </BankingWrapper>
</template>
